import React from "react";
import classes from "../../styles/Gallery.module.css";
import { FaPlay } from "react-icons/fa";

const GalleryVideo = ({ preview, handleClick }) => {
  return (
    <>
      <div className={classes.galleryVideoContainer} onClick={handleClick}>
        <img
          src={preview}
          alt="gallery_video_preview"
          className={classes.GalleryImage}
        />
        <div className={classes.overLay}>
          <div className={classes.playIconContainer}>
            <FaPlay size={15} color="#fff" />
          </div>
        </div>
      </div>
    </>
  );
};

export default GalleryVideo;
